import { pdsTv } from '@nestle-npus-nbm/pds-ui';
import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import { merge } from 'lodash';
import React from 'react';
import { Container } from 'react-bootstrap';
import ProductList from 'src/components/product_list/ProductList';
import { CMS_THEME } from '../../common/enums';
import { StorageContentBlock } from '../common/StorageContentBlock/StorageContentBlock';

interface StorageProductCardsProps {
  node: IStorageProductCards;
}

const DefaultSettings = {
  entity_heading: {
    element: 'h2',
    style: 'typography_h2',
  },
  entity_variant: {
    theme: CMS_THEME.LIGHT,
  },
};

const wrapper = pdsTv({
  base: 'pds-py-4.5 md:pds-py-5.5',
  variants: {
    theme: {
      light: 'pds-bg-surface pds-text-surface-text',
      dark: 'pds-bg-surface-text pds-text-surface',
      neutral: 'pds-bg-surface-layer pds-text-surface-text',
    },
  },
});

const StorageProductCards: React.FC<StorageProductCardsProps> = function ({ node: productCards }) {
  const settings = merge({}, DefaultSettings, productCards?.behaviors);
  const cmsTheme = settings.entity_variant.theme;
  const { products } = productCards.relationships;

  return (
    <div
      id={productCards.component_id}
      data-id={productCards.drupal_id}
      className={wrapper({ theme: cmsTheme })}
    >
      <Container>
        <StorageContentBlock
          node={{ ...productCards, behaviors: settings }}
          className="pds-mb-4.5 md:pds-mb-5.5"
        />
        <ProductList
          productsList={products}
          theme={cmsTheme}
          onClick={title => {
            sendIt({
              event: 'module_interaction',
              eventParams: {
                component_id: title,
                component_type: 'product_card',
                content_name: 'product_card: products',
              },
            });
          }}
        />
      </Container>
    </div>
  );
};

export default StorageProductCards;
